import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import MultiSelectBox from '../../../../../../../features/components/Form/MultiSelectBox'

import { getLoadOptionsHandlerCursorPagination } from '../../../../../../../features/helpers/componentsHelpers'

import { getGoogleAdManagerLabelsService } from '../../../../../../../modules/services/rights'

import { selfAccountSelector } from '../../../../../../../modules/selectors/selfAccounts'

import { GAM_NETWORK_CODE } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'
import { LABELS } from '../../fields'

const LabelsSelect = ({ formik }) => {
  const { values, setFieldValue } = formik

  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const formatOptions = useCallback(options => {
    return options.map(option => ({
      ...option,
      value: option.id,
      label: option.name
    }))
  }, [])

  const loadOptions = useMemo(() => {
    return getLoadOptionsHandlerCursorPagination({
      getOptionsService: getGoogleAdManagerLabelsService,
      params: {
        network_code: gamNetworkCode
      },
      formatOptions: formatOptions
    })
  }, [formatOptions, gamNetworkCode])

  return (
    <MultiSelectBox
      loadOptions={loadOptions}
      value={values[LABELS]}
      name={LABELS}
      setFieldValue={setFieldValue}
      placeholder="Add a label"
      portaled={true}
    />
  )
}

export default LabelsSelect
